/// <amd-module name="Artifacts/Connect/tools/nuget/Protocol" />
import { CopyableCode } from "Artifacts/Connect/components/Common";
import * as Res from "Artifacts/Connect/Resources";
import { PackagingService } from "Artifacts/Connect/services/PackagingService";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { IProtocol } from "Artifacts/Connect/types/IProtocol";
import * as React from "react";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

export class NugetProtocol implements IProtocol {
  readonly name = "NuGet";
  readonly area = "nuget";

  nugetConfig(source: string, feedIndexUrl: string): JSX.Element {
    return (
      <React.Fragment>
        <pre className="secondary-text">{`<?xml version="1.0" encoding="utf-8"?>
<configuration>
  <packageSources>
    <clear />`}</pre>
        <pre>{`    <add key="${source}" value="${feedIndexUrl}" />`}</pre>
        <pre className="secondary-text">{`  </packageSources>
</configuration>`}</pre>
      </React.Fragment>
    );
  }

  nugetPackageSource(source: string, feedIndexUrl: string) {
    return `<add key="${source}" value="${feedIndexUrl}" />`;
  }

  getNuGetProjectSetUp(source: string, url: string, format: string): JSX.Element {
    return (
      <React.Fragment>
        <p className={format}>
          <FormatComponent format={Res.ProjectSetup_Nuget_Details}>
            <code>nuget.config</code>
            <code>.csproj</code>
            <code>.sln</code>
          </FormatComponent>
        </p>
        <CopyableCode text={this.nugetPackageSource(source, url)} ariaLabel={Res.ProjectSetup}>
          {this.nugetConfig(source, url)}
        </CopyableCode>
      </React.Fragment>
    );
  }

  public getFeedUrl(packagingService: PackagingService, feed: ICombinedFeedView) {
    // TODO: Move route resolution to endpoints within this object
    const path = replaceRouteValues("_packaging/{feedId}/{area}/v3/index.json", {
      feedId: feed.name,
      area: this.area,
    });

    return packagingService.getUrl(feed.project, path);
  }
}
